app.formFeedbackBOPZ = {

    settings: {
        formSelector: "#form-complaint-bopz",
        $form : $("#form-complaint-bopz")
    },

    init: function() {

        app.formFeedbackBOPZ.settings.$form.on("submit", app.formFeedbackBOPZ.submit);
        app.formFeedbackBOPZ.toggleFields();
    },

    toggleFields: function() {

        app.formFeedbackBOPZ.settings.$form.find("[name='pvpcontact']").on('change', function(){

            var pvpcontactVal = app.formFeedbackBOPZ.settings.$form.find("[name='pvpcontact']:checked").val();

            if ( pvpcontactVal === "Ja" ) {

                app.formFeedbackBOPZ.settings.$form.find("#row-pvpname").removeClass("hide");
                app.formFeedbackBOPZ.settings.$form.find("#pvpname").attr("required", true);
                app.formFeedbackBOPZ.settings.$form.find("#row-allowpvpinfo").addClass("hide");
            }
            else {

                app.formFeedbackBOPZ.settings.$form.find("#row-pvpname").addClass("hide");
                app.formFeedbackBOPZ.settings.$form.find("#pvpname").removeAttr("required");
                app.formFeedbackBOPZ.settings.$form.find("#row-allowpvpinfo").removeClass("hide");
            }
        });
    },
    submit: function(ev){

        ev.preventDefault();

        app.formFeedbackBOPZ.settings.$form.find(".btn").removeClass("btn--delta icon--paper-plane btn--dota icon--check").addClass("btn--epsilon icon--spinner").html("Bericht verzenden");

        context.submit({
            method: "submitFeedbackformBopz",
            form: app.formFeedbackBOPZ.settings.formSelector,
            onSuccess: function(response){

                app.formFeedbackBOPZ.showSuccess();
                app.formFeedbackBOPZ.clearForm();
            },
            onError: function(){
                app.formFeedbackBOPZ.showError();
            }
        });
    },

    showSuccess: function() {
        app.formFeedbackBOPZ.settings.$form.find(".btn").removeClass("btn--delta icon--paper-plane btn--epsilon icon--spinner").addClass("btn--dota icon--check").html("Succesvol verzonden");
    },

    showError: function() {
        // alert("Uw bericht kon niet verstuurd worden");
    },

    clearForm: function(){
        app.formFeedbackBOPZ.settings.$form.find("[name=firstname]").val("");
        app.formFeedbackBOPZ.settings.$form.find("[name=surname]").val("");
        app.formFeedbackBOPZ.settings.$form.find("[name=gender]").val("Man");
        app.formFeedbackBOPZ.settings.$form.find("[name=dateofbirth]").val("");
        app.formFeedbackBOPZ.settings.$form.find("[name=address]").val("");
        app.formFeedbackBOPZ.settings.$form.find("[name=zipcity]").val("");
        app.formFeedbackBOPZ.settings.$form.find("[name=phone]").val("");
        app.formFeedbackBOPZ.settings.$form.find("[name=email]").val("");
        app.formFeedbackBOPZ.settings.$form.find("[name=home]").val("");
        app.formFeedbackBOPZ.settings.$form.find("[name=firstname-related]").val("");
        app.formFeedbackBOPZ.settings.$form.find("[name=surname-related]").val("");
        app.formFeedbackBOPZ.settings.$form.find("[name=gender-related]").val("Man");
        app.formFeedbackBOPZ.settings.$form.find("[name=relation]").val("");
        app.formFeedbackBOPZ.settings.$form.find("[name=organisation]").val("");
        app.formFeedbackBOPZ.settings.$form.find("[name=department]").val("");
        app.formFeedbackBOPZ.settings.$form.find("[name=employees]").val("");
        app.formFeedbackBOPZ.settings.$form.find("[name=period]").val("");
        app.formFeedbackBOPZ.settings.$form.find("[name=message]").val("");
        app.formFeedbackBOPZ.settings.$form.find("[name=pvpcontact-yes]").trigger("click");
        app.formFeedbackBOPZ.settings.$form.find("[name=pvpname]").val("");
        app.formFeedbackBOPZ.settings.$form.find("[name=allowpvpinfo-yes]").trigger("click");
    }
};